import axios from "axios";
import _, {isEmpty} from 'lodash';
import config from "./config";

export function removeSlash(id){
    try {
        return id.replaceAll('/', '_$_');
    } catch (e) {
        console.error('removeSlash error', e);
        return null
    }
}

export function idsFilter(ids,idname,eqfunction){
    let _idname = idname ? idname : "_id";
    let _eqfunction = eqfunction ? eqfunction : "eq";
    if(_.isString(ids)) {
        return `${_idname} ${_eqfunction} ${ids}`;
    }
    let filter = '';
    if(ids && ids.length>0) {
        _.forEach(ids, id => {
            if (filter.length > 0) {
                filter = `${filter} OR ${_idname} ${_eqfunction} '${id}'`
            } else {
                filter = `${_idname} ${_eqfunction} '${id}'`
            }
        })
    }else {
        return `_id eq '#noidstofind#'`;
    }
    return filter;
}


class API {
    static getDictByURL(url, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + url, {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static getDictWithParamsByURL(url, params) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + url, {
                params,
                paramsSerializer: (params) => {
                    let result = '';
                    Object.keys(params).forEach(key => {
                        // result += `${key}=${encodeURIComponent(params[key])}&`;
                        // result += `${key}=${encodeURIComponent(params[key]).replace('+', '%20')}&`;
                        result += `${key}=${encodeURIComponent(params[key]).replaceAll('%20', ' ')}&`;
                        // result += `${key}=test&`;
                    });
                    return result.substring(0, result.length - 1);
                }
            }).then(response => {
                resolve(response.data);
            });
        });
    }

    /*
        POST /unity/rest/API/1.1/wards/updatePatientInWard HTTP/1.1
        Host: demo-api-agyle:8080
        Authorization: Bearer...
        Content-Length: 187

        {
            "patientInWardId":"613889b5bb6b7f4eb118349e",
            "set":[
                {"metadata.test":123},
                {"bed":"3A"},
                {"seen": { "who":"test", "when":"2020-01-01"} }
            ]
        }

        --------------------------
        true
    */
    static updatePatientInWard(patientInWardId, data, dataDate) {
        let objectSave = {
            patientInWardId: removeSlash(patientInWardId),
            set: data,
        }
        if (dataDate?.length > 0) objectSave["setDate"] = dataDate;

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/updatePatientInWard", {
                "updates": [objectSave]
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static updateBulkPatientsInWard(data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/wards/updatePatientInWard', {
                'updates': data,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static findPatients(body) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/findPatients", body).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static findDischargedPatientsInWard(body) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/findDischargedPatientsInWard", body).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static findPatientsInWard(body) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/findPatientsInWard", body).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static findPatientInWard(data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/wards/findPatientInWard', data).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static findPatientInWardById(id) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/wards/findPatientInWard/${id}`).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static updatePatientsInWard(dataToSet) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/updatePatientInWard", {
                "updates": dataToSet
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getWardsAttendances(wards) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/getPatientsByWards", wards).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getWardsAttendancesUpdates(wards, patients, signal) {
        return new Promise(async function (resolve, reject) {
            axios
                .post(config.apiUrl + "/wards/getPatientsInWardsChanges", {
                    wardIds: wards,
                    versions: patients,
                }, {
                    signal,
                    headers: {
                        autoRefresh: true
                    }
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getPatientByID(patientId) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId)).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static rerenderDocument(docId) {
        //https://demo.fortrus.com/unity/rest/API/1.1/documents/U1JDX1VOSVRZU1RPUkUvNWViNTU3MjYwMjJkMjE3ZDI4Y2M5ZjMz/rerenderDocument
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/documents/" + docId + "/rerenderDocument",{}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getDocument(documentId, patientId) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/patients/${removeSlash(patientId)}/documents/${documentId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static deleteDocument(documentId, reason, msgId) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/documents/${documentId}/delete`, {
                reason: reason
            }).then(response => {
                if(msgId && process.env.BUILD_MODULE == "main" && config.modules?.holdingPen?.mailStatusText?.mailService) {
                    axios.get(`${config.modules?.holdingPen?.mailStatusText?.mailService}/reply_email?msg_id=${msgId}&msg_txt=${config.modules?.holdingPen?.mailStatusText?.rejected}`).then(mailResp => {
                        console.debug(mailResp);
                    }).catch(mailErr => {
                        console.error(mailErr);
                    });
                }
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });;
        });
    }

    static deleteDocumentNoReason(documentId) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/documents/${documentId}/delete`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });;
        });
    }

    static deleteStudy(studyId, reason) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/documents/${studyId}/deleteByMeta/study`, {
                reason: reason,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static moveDocument(documentId, newPatientNumber, msgId) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/documents/${documentId}/transfer/${newPatientNumber}`).then(response => {
                if(msgId && process.env.BUILD_MODULE == "main" && config.modules?.holdingPen?.mailStatusText?.mailService) {
                    axios.get(`${config.modules?.holdingPen?.mailStatusText?.mailService}/reply_email?msg_id=${msgId}&msg_txt=${config.modules?.holdingPen?.mailStatusText?.accept}`).then(mailResp => {
                        console.debug(mailResp);
                    }).catch(mailErr => {
                        console.error(mailErr);
                    });
                }
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getNoteAudit(patientId, noteId, signal) {
        // /unity/rest/API/1.1/patients/D9010020/clinicalNotes/6148886ca2695b4fefa19a96/history
        // /unity/rest/API/1.1/patients/H521354/clinicalNotes/61926119961a977ff5be8bcf
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/patients/${removeSlash(patientId)}/clinicalNotes/${noteId}/history`, {signal}).then(response => {
                resolve(response.data);
            });
        });
    }

    static updateDocumentData(data, documentId) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/documents/" + documentId + "/setMetadata", data).then(response => {
                resolve(response.data);
            });
        });
    }

    static downloadDocument(documentId, params) {
        return new Promise(function (resolve, reject) {
            axios({
                url: `${config.apiUrl}/documents/${documentId}/content`,
                params: params,
                method: "GET",
                responseType: "blob",
            }).then(response => {
                resolve(response);
            });
        });
    }

    static downloadDocuments(documents) {
        return new Promise(function (resolve, reject) {
            axios({
                url: `${config.apiUrl}/documents/contents`,
                data: documents,
                method: "POST",
                responseType: "blob",
            }).then(response => {
                resolve(response);
            });
        });
    }

    static updateDocumentsData(dataByDocumentId) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/documents/metadata/bulkUpdate", dataByDocumentId).then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    static addPatient(data) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/registration", data).then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getDocumentsForPatientByID(patientId) {
        const cfg = {
            params: {
                // sort on API level due to metadata modifications on 'UnityStore plugin mappers'
                // eslint-disable-next-line no-useless-escape
                $sort: config.modules.patient.documentsSort,
            },
        };
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId) + "/documents", cfg).then(response => {
                _.remove(response.data.__data, element => {
                    return element.repositoryId !== "SRC_UNITYSTORE";
                });
                resolve(response.data);
            });
        });
    }

    static getMetadataForDocuments(patientId, documentsArrayId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/documents/getMetadata", {
                documentIds: documentsArrayId,
            }, {signal}).then(response => {
                resolve(response.data);
            });
        });
    }

    static getSearchList(options, signal, disableRetry = false) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/$search', options, {signal, stopRetry: disableRetry})
                .then(response => {
                    resolve({data: response.data, status: response.status});
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getOperations(options) {
        const cfg = {
            params: options
        };
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/admission", cfg).then(response => {
                resolve({data: response.data, status: response.status});
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static getAuditsList(options, signal) {
        const cfg = {
            params: options,
            signal
        };
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/audit", cfg).then(response => {
                resolve({data: response.data, status: response.status});
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static async getGpDetails(gp) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + gp.href).then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }

    static async getSurgeryDetails(surgery) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + surgery.href).then(response => {
                if(response.status === 200)
                    resolve( response.data);
                else
                    resolve(null)
            });
        });
    }

    static getPref(userID) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/users/current/preferences/custom").then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }

    static getUserCurrent(userID) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/users/current").then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }

    static getUsers(filterString) {
        return new Promise(async function (resolve, reject) {
            axios.get(`${config.apiUrl}/users${filterString ? `${filterString}` : ""}`).then(response => {
                // resolve({data: response.data, status: response.status});
                resolve({data: response.data, status: response.status});
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static async getFormSet(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/formsets", {signal}).then(response => {
                let res = response.data.__data.find(el => el.name === "Agyle Forms");
                resolve(res.formTypes);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static setPref(data) {
        return new Promise(async function (resolve, reject) {
            axios.put(config.apiUrl + "/users/current/preferences/custom", data).then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }

    static setCurrentPref(preference, data) {
        return new Promise(async function (resolve, reject) {
            let payload = {};
            payload['path'] = preference;
            payload['value'] = data;
            axios.put(config.apiUrl + "/users/current/preferences/savePreference/", payload).then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }

    static async saveObservation({patientId, observation}) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/observations", observation).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * @deprecated Use `getFullObservations` instead.
     */
    static async getObservations({patientId, type, patientInWardId, skipCancelled}, signal) {
        let filter;
        if (type) {
            filter = "procedure.name eq '" + type + "'";
        }
        if (patientInWardId) {
            if (filter) {
                filter += " and ";
            } else {
                filter = "";
            }
            filter += "patientsInWardsRef.refId eq '" + patientInWardId + "'";
        }
        if (skipCancelled) {
            if (filter) {
                filter += " and ";
            } else {
                filter = "";
            }
            filter += "status ne 'cancelled'";
        }
        const cfg = {
            params: {
                $filter: filter,
                $sort: "examinationStart",
            },
            signal: signal
        };
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId) + "/observations", cfg).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    /**
     * Fetches full observations for a given patient in ward and procedure.
     *
     * @param {Object} patientInWard - The patient in ward object.
     * @param {string} procedure - The procedure to filter observations.
     * @param {boolean} [skipCancelled=false] - Whether to skip cancelled observations.
     * @param {AbortSignal} [signal=null] - Optional signal to abort the request.
     * @returns {Promise<Object|null>} - A promise that resolves to the observations data or null if invalid input.
     */
    static async getFullObservations(patientInWard, procedure, skipCancelled = false, signal = null) {
        if (!patientInWard?.__id || !patientInWard?.patient) {
            console.error('getFullObservations: patientInWard is not valid');
            return null;
        } else if (!procedure) {
            console.error('getFullObservations: procedure is not valid');
            return null;
        }
        const patientIds = [patientInWard.patient.__id];
        const mergedNumbers = patientInWard.patient?.patientNumbers?.filter(nub => nub?.type?.toLowerCase() === 'merged') || [];
        mergedNumbers.forEach(merged => patientIds.push(merged.number));

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/patients/observations', {
                patientIds: patientIds,
                patientsInWardsId: patientInWard.__id,
                procedure,
                skipCancelled,
            }, {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static async cancelObservation({patientId, observationId}) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + "/patients/" + removeSlash(patientId) + "/observations/" + observationId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }


    // Change status of next observation
    // Example of Data
    // {
    //   "nextObsDate": "2021-12-15T13:05:10",
    //   "nextObsStatus": "test",
    //   "nextObsReason": "test"
    // }
    static async changeNextObsStatus(patientId, observationId, data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/observations/" + observationId + "/updateNextObs", data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
                console.error(error);
            });
        });
    }

    // Update Obs test timestamp
    static updateObservationTests(patientId, obsId, tests) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + `/patients/${removeSlash(patientId)}/observations/${obsId}/updateTests`, {
                "tests": [...tests]
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static addClinicalNoteComment(patientId, note_id, comment) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/" + note_id + "/addComment", comment).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static hideClinicalNote(patientId, note) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/" + note.__id + "/hide", "").then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static cancelClinicalNoteByRefId(patient, refId) {
        return new Promise(function (resolve, reject) {
            // Fake body note
            const note = {
                note: "",
                recordType: "type",
                patientsInWardsRef: [patient?.__id],
                cancelReason: ""
            };

            axios.post(config.apiUrl + "/patients/" + removeSlash(patient?.patient?.__id) + "/clinicalNotes/cancel/ref/" + refId, note).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static updateClinicalNote(patientId, note) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/" + note.__id, note).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static addClinicalNote(patientId, note) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/add", note).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static addBulkClinicalNote(ids, note) {
        const data = {
            ids,
            note,
        }
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/clinicalNotes/add", data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static async getClinic(clinicId, signal) {
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + "/clinics/" + removeSlash(clinicId), {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }


    static async getClinics(filter, signal) {
        const filterText = `?$filter=${encodeURIComponent(filter)}`;
        let url = config.apiUrl + "/clinics";

        if (filter) {
            url += filterText;
        }

        return new Promise(function (resolve, reject) {
            axios
              .get(url, { signal })
              .then((response) => {
                  resolve(response.data);
              })
              .catch((error) => {
                  if (error?.message !== "canceled") {
                      reject(error);
                  }
              });
        });
    }


    static async getSurgery(surgeriesId, signal) {
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + "/surgeries/" + removeSlash(surgeriesId), {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static async getClinicalNotes(patientId, patientInWardId, signal) {
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes?$filter=patientsInWardsRef.refId eq '" + removeSlash(patientInWardId) + "'", {signal}).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static async getAllClinicalNotesForPatient(patientId, signal) {
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + `/patients/${removeSlash(patientId)}/clinicalNotes`, {signal}).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static async getClinicalNotesForPatientByIds(patientInWard, patientsInWardsId, signal) {
        if (!patientInWard?.__id || !patientInWard?.patient) {
            console.error('getFullObservations: patientInWard is not valid');
            return null;
        }

        const patientIds = [patientInWard.patient.__id];
        const mergedNumbers = patientInWard.patient?.patientNumbers?.filter(nub => nub?.type?.toLowerCase() === 'merged') || [];
        mergedNumbers.forEach(merged => patientIds.push(merged.number));

        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + `/patients/clinicalNotes`, {
                patientIds: patientIds,
                patientsInWardsId,
            }, {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    static async getClinicalNotesHis(patientId, patientInWardId) {
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes?history=true&&$filter=patientsInWardsRef.refId eq '" + removeSlash(patientInWardId) + "'").then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static cancelNoteWithReason(patientId, noteId, cancelReason, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/cancel/" + noteId, {cancelReason: cancelReason}, {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static cancelNoteWithReasonByRefId(patientId, refId, cancelReason, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/clinicalNotes/cancel/ref/" + refId, {cancelReason}, {signal}).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static updateWardData(wardId, data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + `/wards/${encodeURIComponent(wardId)}/data`, {
                "set": data
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getWardData(wardId, data) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/wards/${encodeURIComponent(wardId)}/data`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getWardsData(ids) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/wards/data/multiple', ids)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getPatientAttendance(patientData) {
        const { patientId, attendanceId } = patientData

        const data = {
            "attendanceTypes": [
                "E"
            ],
            patientId,
            attendanceId
        }

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/findPatientAttendances", data).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getPatientClinicVisits(patientId) {
        const data = {
            attendanceTypes: ['O'],
            patientId: patientId
        };

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/findPatientAttendances?$expand=clinic,consultant", data).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getPatientAttendanceTCI(wardId) {
        const data = {
            attendanceTypes: ['O', 'W', 'I', 'E', 'WA'],
            startDate: new Date(),
            wardCodeOrSpecialtyId: wardId || null
        };

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/findPatientAttendances?$expand=patient", data).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static async getPatientAttendancesHistory(patientId) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/getPatientHistory", {
                "patientId": patientId
            }).then(response => {
                resolve(response.data.__data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getPatientAdditionalData(patientId) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId) + "/data").then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getPatientsAdditionalData(patientIds) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/patients/data/list', patientIds)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static updatePatientAdditionalData(patientId, data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/" + removeSlash(patientId) + "/data", {
                "set": [{
                    "other": data
                }]
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static discharge(data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/discharge", data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static transfer(data, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/wards/transfer", data, {signal}).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    // Hospitals list for discharge patient
    static getHospitals(filter, signal) {
        let filterText = '';
        if (!isEmpty(filter)) filterText = `?$filter=${encodeURIComponent(filter)}`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + '/hospitals' + filterText, {signal})
                .then(response => {
                    resolve({data: response.data, status: response.status});
                }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    // Wards list
    static getAllWards(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/wards?$filter=${encodeURIComponent('deactivated ne true')}`, {signal}).then(response => {
                resolve({data: response?.data?.__data, status: response.status});
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }
    static getWard(id,signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/wards/${id}`, {signal}).then(response => {
                resolve(response.data);
            });
        });
    }
    // Wards list for CSM Contact Time
    static getWards(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/wards?$filter=" + encodeURIComponent("(forCSM eq 1 or forCSM eq true) and deactivated ne true"), {signal}).then(response => {
                resolve({data: response.data, status: response.status});
            });
        });
    }
    static getWardsByIds(ids,signal) {
        return new Promise(async function (resolve, reject) {
            if(ids && ids.length > 0) {
                axios.get(config.apiUrl + "/wards?$filter=" + encodeURIComponent(idsFilter(ids)), {signal}).then(response => {
                    resolve(response.data);
                });
            }else {
                reject('no wards ids to find')
            }
            // TODO: error handling ???
        });
    }

    // Pre Registered Lists
    static getPreReg(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/attendances/prereg?$expand=patient", {signal}).then(response => {
                resolve({data: response.data, status: response.status});
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    // Audit Method
    static audit(data, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/audit",
                {
                    "auditType": "E",
                    "auditData": {
                        ...data
                    },
                    "objectName": "agyle"
                }, {signal}
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static eyonixAudit(auditType, data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/audit",
                {
                    auditType: auditType,
                    ...data
                }, {}
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static getPatientsSmartFilter(options) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.reportsUrl + "patients_smart_filters",
                options, {}
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }



    // Statistic data to Agyle Dashboard
    static getStatistic(from, to, wardsList, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/stats/agyle",
                {from, to, wardsList}, {signal}
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    // Statistic data to Agyle Dashboard
    static getLiveDashboard(from, to, wardsList, majorsBeds, utcBeds, acaBeds, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/stats/liveDashboard',
                {from, to, wardsList, majorsBeds, utcBeds, acaBeds}, {signal},
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== 'canceled') {
                    reject(error);
                }
            });
        });
    }

    // Statistic data to Agyle Dashboard
    static getTimelineStatistic(from, to, wardsList, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/stats/timeline",
                {from, to, wardsList}, {signal}
            ).then(response => {
                resolve(response);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                }
            });
        });
    }

    static getAllTrustedDevices() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/auth/trusted-devices",
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }


    static getTrustedDevices() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/auth/trusted-devices?$filter=isTrusted eq true",
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static isTrustedDevice(deviceId) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/auth/trusted-devices/isTrusted",
                {deviceId},
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static addTrustedDevices(data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/auth/trusted-devices/set",
                data,
            ).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static removeTrustedDevice(deviceId) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + `/auth/trusted-devices/${deviceId}`,
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static getUserPin() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/auth/pin-codes",
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static setPinUser(username, pin) {
        const dataToPass = {
            userName: username,
            pinCode: pin
        }
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/auth/pin-codes/set",
                dataToPass,
            ).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static deactivateUserPin(userId) {
        return  new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + `/auth/pin-codes/${userId}`)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getAnnouncement() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/announcement"
            ).then(response => {
                if (!_.isEmpty(response?.data?.__data)) {
                    resolve(response?.data?.__data);
                } else {
                    resolve([]);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    static setAnnouncement(announcement) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/announcement", announcement)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static deleteAnnouncement(id) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + "/announcement/" + id)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getMaintenance() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/customdata/upgrade")
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getAllUrinalysis(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/urinalysis", {signal})
                .then(response => {
                    if (response?.status === 200 && response.data && response.data.__data) {
                        resolve(response.data.__data);
                    }
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getUrinalysis(id, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/urinalysis/" + id, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static setUrinalysis(data, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/urinalysis", data, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getIceReports(ptId, signal) {
        return new Promise(async function (resolve, reject) {
            const filter = `patient_id eq '${removeSlash(ptId)}'`;

            axios.get(config.apiUrl + `/icereports?$filter=${encodeURIComponent(filter)}`, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static requestForIceReports(ptId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/patients/${removeSlash(ptId)}/icereports`, {signal, stopRetry: true})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static checkPatientAdmission(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/admission/checkPatient", obj, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static admitPatient(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/admission", obj, {signal, stopRetry: true})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static admitWithMerge(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/admissionMergeRequest", obj, {signal, stopRetry: true})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static patientAdmission(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/attendances/admissionRequest", obj, {signal, stopRetry: true})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static admitWithBedBooking(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/bedbooking", obj, {signal, stopRetry: true})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static checkBedOccupied(wardId, bedId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/wards/${wardId}/bed/${bedId}`, {signal})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getPatientHistory(wardIds, dateFrom, dateTo, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + `/wards/getPatientHistory`, {
                    wardIds,
                    dateFrom,
                    dateTo,
                }, {signal})
                .then(response => {
                    resolve(response?.data?.__data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    /*
     *  Ward Map Creator Methods
     */

    static getWardMap(code, signal) {
        return new Promise(async function (resolve, reject) {
            const prefix = `code eq '${code}'`;
            axios.get(config.apiUrl + `/maps?$filter=${encodeURIComponent(prefix)}`, {signal})
                .then(response => {
                    if (response?.data && response?.data?.__data && response?.data?.__data?.length > 0) {
                        resolve(response?.data?.__data[0]);
                    } else {
                        resolve(null);
                    }
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }


    static getWardMapList(id,byField='wardsId', signal) {
        return new Promise(async function (resolve, reject) {
            let filter = "";
            if (id) {
                const prefix = idsFilter(id,byField);
                filter = `?$filter=${encodeURIComponent(prefix)}`;
            }

            axios.get(config.apiUrl + "/maps" + filter, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updateWardMapList(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/maps", obj, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static deleteMap(code, signal) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + "/maps/" + code, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getAllBedsAndAreas(code, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/maps/" + code, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getBed(id, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + '/maps/bed/' + id, {signal})
                .then(response => {
                    resolve(response?.data || null);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getAllBeds(wardId, signal) {
        return new Promise(async function (resolve, reject) {
            let suffix = wardId ? `/ward/${encodeURIComponent(wardId)}` : '';
            axios.get(config.apiUrl + "/maps/beds" + suffix, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static archiveBed(bedId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + "/maps/beds/" + bedId, {signal})
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updateBed(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/maps/beds", obj, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getAllAreas(wardId, signal) {
        return new Promise(async function (resolve, reject) {
            let suffix = wardId ? `/ward/${encodeURIComponent(wardId)}` : '';
            axios.get(config.apiUrl + '/maps/areas' + suffix, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static deleteArea(areaId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.apiUrl + "/maps/areas/" + areaId, {signal})
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updateArea(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/maps/areas", obj, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updateEntireMap({maps, beds, areas}, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/maps/update", {
                maps,
                beds,
                areas
            }, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static checkMapVersion(obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + `/maps/version`, obj, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static getBedBookingPatients({admitted, start, end}, signal) {
        let filter = `status ne 'FINISHED' AND status ne 'CANCELED'`;
        if (admitted) {
            filter = `status eq 'FINISHED' and lastModifiedDate ge_dt '${start}' and lastModifiedDate le_dt '${end}'`;
        }

        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + `/bedbooking?$filter=${encodeURIComponent(filter)}`, {signal})
                .then(response => {
                    resolve(response?.data?.__data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updateBedBookingPatients(id, obj, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/bedbooking/" + removeSlash(id), {
                    "set": obj,
                }, {signal})
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    static updatePatientTags(patientId, tags = [], signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(`${config.apiUrl}/patients/${removeSlash(patientId)}/tags`,
                    {tags}, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static setDeceased(patientId, dod, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(`${config.apiUrl}/attendances/deceased`,
                    {
                        patient: {
                            dod,
                            __id: patientId
                        },
                    }, {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    // ADMIN PAGE
    static getPatientInfo(patientId, signal){
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/patients/" + removeSlash(patientId), {signal})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getMergesList(from, to, signal) {
        let data = {
            "from": from,
            "to": to
        };

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/merge/list", data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static mergePatients(from, to, signal) {
        let data = {
            "from": from,
            "to": to
        };

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/merge", data,{signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static unmergePatient(id, signal) {
        let data = {
            "id": id
        };

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/patients/unmerge", data,{signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getDocumentCount(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/reports/documents/count",{signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getNewCount(days, signal) {
        let data = {
            "days": days
        }
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/reports/documents/getNewCount", data,{signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getAdminDocCountByDate(from, to, signal) {
        let data = {
            "from": from,
            "to": to
        }
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/reports/documents/getNewCountByDate", data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getAdminDocCountByDocType(signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/reports/documents/count/docType", {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static hideDocument(documentId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/documents/" + documentId + "/hide", {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static unhideDocument(documentId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + "/documents/" + documentId + "/unhide", {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getDocAudit(type, typeValue, pageSize, pageNumber,signal) {
        let data = {
            "type": type,
            "typeValue": typeValue,
            "pageSize": pageSize,
            "pageNumber": pageNumber
        }
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + "/reports/documents/audit", data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getHl7Stat(signal) {
        let uri = `/hl7admin/stat/all`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static sendCommandHl7(command, node, signal) {
        let data = {command: command, nodes: [node]};
        let uri = `/hl7admin/control`;
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static sendMessageHL7(message, signal) {
        let data = {message: message};
        let uri = `/hl7admin/sendmessage`;
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    /*
     *  Book Admission Methods
     */

    static getSesions(from, to, opType) {
        let type = opType === "TCI" ? "IP,DC,TCI" : "MDU";

        let uri = `/theatresessions/findindates?startDate=${from}&endDate=${to}&opType=${type}`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getSessionsToAdd(from, to, opType, spec) {

        let filter = `day gt_dt '${from}' and opType eq '${opType}' and active eq true and locked eq false `;
        if(spec) filter += `and specialty.code eq '${spec}'`;

        let params  = {
            $filter : filter,
            $sort: "day"
        };

        const cfg = {
            params: params,
        };


        let uri = `/theatresessions/`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri,cfg)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getSesionsByIds(ids) {
        let filter = "";
        for(let id of ids) {
            if(filter.length>0) {
                filter+= ' or '
            }
            filter+= `_id eq '${id}'`
        }
        let params  = {
            $filter : filter
        };

        const cfg = {
            params: params,
        };

        let uri = `/theatresessions`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, cfg)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getHistoryOperation(id) {

        const cfg = {
        };

        let uri = `/admission/history?id=`+id;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, cfg)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getOperation(filter) {
        let options = {
            $sort: "!_createdDate"
        };

        const cfg = {
            params: options,
        };

        let uri = `/admission?$filter=${encodeURIComponent(filter)}&expand='true'`;

        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, cfg)
                .then(response => {
                    resolve(response.data.__data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getUnscheduledOperation(page = 1, filter) {
        let options = {
            $page: page,
            $pageSize: 100,
            $sort: "!_createdDate"
        };

        const cfg = {
            params: options,
        };

        let uri = `/admission/unscheduled?$filter=${encodeURIComponent(filter)}&expand='true'`;

        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, cfg)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }


    static getTheatres(type, signal) {
        let uri = `/theatres?$filter= `;
        if(type) uri += `opType ${type === "MDU"? "eq": "ne"} 'MDU'`
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(_.sortBy(response.data.__data, ["description"]));
                }).catch(error => {
                reject(error);
            });
        });
    }

    static theatreSessionsUpdate(data, signal) {
        let uri = `/theatresessions/update`;
        if(data['status'] === "SEND") {
            data['status'] = "PENDING"
        }
        if(data['status'] === "history") {
            data['status'] = "PENDING"
        }

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static theatreSessionsAddOperation(data) {
        let uri = `/theatresessions/book?theatreSessionId=${data.theatreSessionId || null}&holdingPen=${data.holdingPen || false}&cancelStatus=${data.cancelStatus || null}&operationId=${data.operationId || null}&time=${data.time}&opTimeLen=${data.opTimeLen||null}&remove=${data.remove || null}&comment=${data.comment}&lock=${data.lock || false}&workStationId=${data.workStationId || null}`;
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri,{})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }
    static getAdmissionConfig(signal) {
        let uri = `/admission/getConfig`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }
    static getWorkstations(signal) {
        let uri = `/theatresessions/workstations`;
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }
    static getConsultants(signal, filter) {
        let uri = `/consultants?&$filter=(inactive ne true) AND deactivated ne true`;
        if(filter){
            uri += " " + filter;
        }
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    console.error("reject", error);
                reject(error);
            });
        });
    }

    static getConsultantsByIds(ids, signal) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/consultants', ids, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                console.error('reject', error);
                reject(error);
            });
        });
    }

    static getDefaultAdmissionConsultants(signal, filter) {
        let uri = `/admissionConsultant`;

        if(filter){
            uri += `?&$filter=${filter}`;
        }
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + uri, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    console.error("reject", error);
                reject(error);
            });
        });
    }

    static updateDefaultAdmissionConsultants(signal, data) {
        let uri = `/admissionConsultant`;

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    console.error("reject", error);
                reject(error);
            });
        });
    }

    static admissionUpdate(data, signal) {
        let uri = `/admission/update`;
        if(data['status'] === "SEND") {
            data['status'] = "PENDING"
        }
        if(data['status'] === "history") {
            data['status'] = "PENDING"
        }

        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getICEServiceResponse(patientId, type, requestingOrganisation, signal) {
        let uri = `/externalsystemlinks/getICEServiceResponse`;
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, {
                    patientId,
                    type,
                    requestingOrganisation,
                    mode: 'xml',
                }, {signal, stopRetry: true})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getBookAdmissionStatistics(data, signal) {
        let uri = "/theatresessions/statistics";
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + uri, data, {signal})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }
    //holdingPen

    static backDocumentToHoldingPen(id) {
        let uri = `/admin/${id}/transfer/HOLDINGPEN`;
        return new Promise(async function (resolve, reject) {
            axios.post(config.contentService + uri,{})
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getExternalConfig() {
        return new Promise(async function (resolve, reject) {
            axios.get(config.apiUrl + '/config/agyle')
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static saveExternalConfig(data) {
        return new Promise(async function (resolve, reject) {
            axios.post(config.apiUrl + '/config/agyle', data)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(error);
            });
        });
    }

    static getLocationsDict() {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/$dict/Locations`).then(response => {
                resolve(response.data);
            });
        });
    }

    static saveBedRequest(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/bedRequest`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }

    static getBedRequest(filter) {
        let uri = `/bedRequest`;
        if (filter) {
            uri += `?$filter=${encodeURIComponent(filter)}`;
        }
        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + uri)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }

    static getPatientsWithBedRequest(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/bedRequest/getPatients`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }

    static getBoardsList(wardId) {
        let uri = `/maps/lists/` + wardId;

        return new Promise(function (resolve, reject) {
            axios.get(config.apiUrl + uri)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }
    static setBoardsList(data) {

        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/maps/lists`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }

    static deleteBoard(boardId) {
        let uri = `/maps/lists/` + boardId;

        return new Promise(function (resolve, reject) {
            axios.delete(config.apiUrl + uri)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);

                });
        });
    }

    static getCustomPatientList() {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/customPatientList`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static setCustomPatientList(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/customPatientList`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static deleteCustomPatientList(listId) {
        return new Promise(function (resolve, reject) {
            axios.delete(`${config.apiUrl}/customPatientList/${listId}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getEscalationLevels(hospitalId = null) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/maps/escalation-level/${hospitalId}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static updateEscalationLevel(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/maps/escalation-level`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getCleaningRequest(filter) {
        let filterString = '';
        if (filter) {
            filterString = `?$filter=${encodeURIComponent(filter)}`;
        }
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/cleaningRequest${filterString}`)
                .then(response => {
                    resolve(response?.data?.__data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static saveCleaningRequest(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/cleaningRequest`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getAuditCleaningRequest(id, signal) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/cleaningRequest/audit/${id}`, {signal})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getDiagnosisMax(snomedCode) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/diagnosis-max/${snomedCode}`)
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getReferralReview(id) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/bars/referrals/${id}`)
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });

    }

    static updateAgyleAssessment(body, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/agyle-assessment`, body, {signal})
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static printBarcode(body, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/print/barcode`, body, {signal, responseType: 'arraybuffer'})
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static getDischargeTemplates(version) {
        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/template-discharge/${version}`)
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    static updateDischargeTemplates(body) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/template-discharge`, body)
                .then(response => {
                    resolve(response?.data);
                })
                .catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
        });
    }

    /*
       ##########################################
       ########     BARS API Section     ########
       ##########################################
    */

    static getBarsSlots(filter) {
        let filterString = '';
        if (filter) {
            filterString = `?$filter=${encodeURIComponent(filter)}`;
        }

        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/bars/slots${filterString}`)
              .then(response => {
                  if (response.data.__data) {
                      resolve(response.data.__data)
                  } else {
                      resolve([])
                  }
              })
              .catch(error => {
                  if (error?.message !== 'canceled') {
                      reject(error);
                  }
              });
        });
    }

    static getBarsSessions(filter) {
        let filterString = '';
        if (filter) {
            filterString = `?$filter=${encodeURIComponent(filter)}`;
        }

        return new Promise(function (resolve, reject) {
            axios.get(`${config.apiUrl}/bars/sessions${filterString}`)
              .then(response => {
                  if (response.data.__data) {
                      resolve(response.data.__data)
                  } else {
                      resolve([])
                  }
                  // resolve(response?.data);
              })
              .catch(error => {
                  if (error?.message !== 'canceled') {
                      reject(error);
                  }
              });
        });
    }

    static addBarsSession(data) {
        return new Promise(function (resolve, reject) {
            axios.post(`${config.apiUrl}/bars/sessions/add`, data)
              .then(response => {
                  resolve(response.data);
              })
              .catch(error => {
                  // if (error?.message !== 'canceled') {
                      reject(error);
                  // }
              });
        });
    }

      static async deleteBarsSession(sessionId) {
        return new Promise(async function (resolve, reject) {
          axios
            .delete(`${config.apiUrl}/bars/sessions/remove/${sessionId}`)
            .then((response) => {
              // console.log("cancelObservation response.data", response.data);
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }

        /*
             ##########################################
             ########     APPOINTMENTS Section     ####
             ##########################################
        */
    static getSessionDateFilter(date) {
        return `(startDate le_dt '${date.format("YYYY-MM-DD HH:mm")}' and endDate ge_dt '${date.format("YYYY-MM-DD HH:mm")}')`
    }
        // SESSIONS
    static async getAppointmentSessions(startDate,endDate,bars,hospitalId) {
        let filters = [];

        const dateConditions = [];

        if (startDate) {
            const f1 = this.getSessionDateFilter(startDate);
            dateConditions.push(f1);
        }

        if (endDate) {
            const f2 = this.getSessionDateFilter(endDate);
            dateConditions.push(f2);

            if (startDate) {
                const f3 = `(startDate ge_dt '${startDate.format("YYYY-MM-DD HH:mm")}' and endDate le_dt '${endDate.format("YYYY-MM-DD HH:mm")}')`;
                dateConditions.push(f3);
            }
        }

        if (dateConditions.length > 0) {
            filters.push(`(${dateConditions.join(' OR ')})`);
        }

        if (hospitalId) {
            filters.push(`(hospitalId eq '${hospitalId}')`);
        }

        const filterQuery = filters.length > 0 ? `?$filter=${encodeURIComponent(filters.join(' and '))}` : '';

        const url = `${config.apiUrl}/${bars ? 'bars/sessions' : 'appointment-sessions'}${filterQuery}`;
        // let filter = '';
        // if(startDate) {
        //     let f = this.getSessionDateFilter(startDate);
        //     filter = `?$filter=${encodeURIComponent(f)}`
        // }
        // if(endDate) {
        //     if(filter.length>0) {
        //         filter = `${filter} OR `
        //     }else {
        //         filter = '?$filter=';
        //     }
        //     let f = this.getSessionDateFilter(endDate);
        //     filter = `${filter}${encodeURIComponent(f)}`
        //
        //     if (startDate && endDate) {
        //         filter += encodeURIComponent(` OR (startDate ge_dt '${startDate.format("YYYY-MM-DD HH:mm")}' and endDate le_dt '${endDate.format("YYYY-MM-DD HH:mm")}')`);
        //     }
        // }
        // if (hospitalId) {
        //     if(filter.length>0) {
        //         // filter = `hospitalId eq '${hospitalId}' AND ${filter}`
        //         filter = `${filter} and (hospitalId eq '${hospitalId}')`
        //     }else {
        //         filter += `?$filter=hospitalId eq '${hospitalId}'`
        //     }
        // }
        // let url = `${config.apiUrl}/${bars ? 'bars/sessions' : 'appointment-sessions'}${filter}`;
        return new Promise(async function (resolve, reject) {
          axios
            .get(url)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async getMonthStats(startDate,sessions,statuses,bars,hospitalId) {
        let data = {sessions:sessions,status:statuses};
        if (hospitalId) data.hospitalId = hospitalId;
        let url = `${config.apiUrl}/${bars ? 'bars/slots' : 'appointment-slots'}/monthStat/${startDate.format('DD-MM-YYYY')}`;
        return new Promise(async function (resolve, reject) {
            axios
                .post(url,data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    static async removeAppointment(id) {
        let url = `${config.apiUrl}/appointment-slots/${id}`;
        return new Promise(async function (resolve, reject) {
            axios
                .delete(url)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }




    static async createAppointmentSession(data) {
        return new Promise(async function (resolve, reject) {
          axios
            .post(`${config.apiUrl}/appointment-sessions`, data)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async bulkCreateAppointmentSessions(data) {
        return new Promise(async function (resolve, reject) {
          axios
            .post(`${config.apiUrl}/appointment-sessions/bulk-create`, data)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }


    static async updateAppointmentSession(sessionId, data) {
        return new Promise(async function (resolve, reject) {
          axios
            .patch(`${config.apiUrl}/appointment-sessions/${sessionId}`, data)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async getAppointmentSession(sessionId, signal) {
        return new Promise(async function (resolve, reject) {
          axios
            .get(`${config.apiUrl}/appointment-sessions/${sessionId}`,{signal})
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async deleteAppointmentSession(sessionId) {
        return new Promise(async function (resolve, reject) {
          axios
            .delete(`${config.apiUrl}/appointment-sessions/${sessionId}`)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    // SLOTS
    static async createAppointmentSlot(data) {
        return new Promise(async function (resolve, reject) {
            axios
              .post(`${config.apiUrl}/appointment-slots`, data)
              .then((response) => {
                  resolve(response.data);
              })
              .catch((error) => {
                  reject(error);
              });
        });
    }

    static async lockAppointmentSlot(data) {
        return new Promise(async function (resolve, reject) {
            axios
              .post(`${config.apiUrl}/appointment-slots/lock`, data)
              .then((response) => {
                  resolve(response.data);
              })
              .catch((error) => {
                  reject(error);
              });
        });
    }

    static async updateAppointmentSlotStatus(sessionId, data) {
        return new Promise(async function (resolve, reject) {
          axios
            .patch(`${config.apiUrl}/appointment-slots/status/${sessionId}`, data)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async getAppointmentSlots(startDate,endDate,bars, addFilter) {
        let filterString = `startDate=${startDate.format('DD-MM-YYYY')}&endDate=${endDate.format('DD-MM-YYYY')}`
        if (addFilter) filterString += `&${addFilter}`;

        return new Promise(async function (resolve, reject) {
          axios
            .get(`${config.apiUrl}/${bars ? 'bars/slots/inDates' : 'appointment-slots/slotsInDates'}?${filterString}`)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

    static async getAppointmentSlot(appointmentSlotId) {
        return new Promise(async function (resolve, reject) {
          axios
            .get(`${config.apiUrl}/appointment-slots/${appointmentSlotId}`)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        });
    }

}

export default API;
